// Vite expone las variables de entorno a través de import.meta.env
// Para compatibilidad, también combinamos con window['env'] para variables dinámicas
export const env = (() => {
  console.log('Cargando variables de entorno...');
  console.log('import.meta.env', import.meta.env);
  const envVars = {
    ...import.meta.env,
    ...window['env']
  };
  console.log('Variables de entorno cargadas:', envVars);
  return envVars;
})();
